import React from 'react'
import {
  Skeleton,
  Empty,
  Icon,
  Tag,
  message,
  Modal,
  Button,
  Select,
} from 'antd'

import Chart from '../../pie-chart'
import List from '../../chart-list'

import WasabiLogo from '../../../../assets/img/wasabi-logo.svg'
import AzureLogo from '../../../../assets/logo/azure-icon.png'
import AwsLogo from '../../../../assets/img/storage/aws.png'

import './styles.scss'

class TotalCostChart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0,
      currentCategory: 'All Categories',
      showingProducts: false,
      products: [],
    }
  }

  componentWillReceiveProps() {
    this.setState({
      currentCategory: 'All Categories',
      showingProducts: false,
      activeIndex: 0,
      products: [],
    })
  }

  setActiveCell = index => {
    this.setState({ activeIndex: index })
  }

  setCurrentCategory = (categoryName, products) => {
    this.setState({
      currentCategory: categoryName,
      showingProducts: true,
      activeIndex: 0,
      products,
    })
  }

  onBack = () => {
    this.setState({
      currentCategory: 'All Categories',
      showingProducts: false,
      activeIndex: 0,
    })
  }

  render() {
    const colors = [
      '#0088FE',
      '#00C49F',
      '#FFBB28',
      '#FF8042',
      '#EC407A',
      '#7E57C2',
      '#EF5350',
      '#AFB42B',
    ]

    const {
      activeIndex,
      currentCategory,
      showingProducts,
      products,
    } = this.state
    const {
      loading,
      error,
      data,
      chartSize,
      accountName,
      provider,
    } = this.props

    let chartData

    if (showingProducts) {
      const productsSum = products
        .map(prod => prod.monthly_actual)
        .reduce((a, b) => a + b, 0)
      chartData = products.map(prod => {
        return {
          value: prod.monthly_actual,
          name: prod.name,
          percent: `${((prod.monthly_actual / productsSum) * 100).toFixed(2)}%`,
          cost: `$ ${prod.monthly_actual.toFixed(2)}`,
        }
      })
    } else {
      chartData = data
    }

    const totalCostPanel = (
      <div className="total-cost-chart">
        <div className="back-btn">
          {showingProducts && (
            <Button shape="circle" icon="left" onClick={this.onBack} />
          )}
        </div>
        <div className="current-category">{currentCategory}</div>
        <div className="chart-side">
          <Chart
            data={chartData}
            colors={colors}
            setActiveCell={this.setActiveCell}
            activeIndex={activeIndex}
            size={chartSize}
          />
        </div>
        <div className="list-side">
          <List
            data={chartData}
            colors={colors}
            setActiveCell={this.setActiveCell}
            activeIndex={activeIndex}
            setCurrentCategory={this.setCurrentCategory}
          />
        </div>
      </div>
    )

    const loadingPanel = (
      <div className="total-cost-chart-loading">
        <Skeleton
          style={{ overflow: 'hidden' }}
          title={false}
          paragraph={{ rows: 10, width: '100%' }}
          active
        />
      </div>
    )

    const emptyPanel = (
      <div className="total-cost-chart-empty">
        <Empty />
      </div>
    )

    const errorPanel = (
      <div className="total-cost-chart-error">
        <h1>
          <Icon type="frown" />
          <span> Could not load data.</span>
        </h1>
      </div>
    )

    let panel

    if (error) panel = errorPanel
    else if (loading) panel = loadingPanel
    else if (!data || !data.length) panel = emptyPanel
    else panel = totalCostPanel

    return (
      <div className="total-cost-chart-wrapper">
        <div className="head">
          <h3>Total Cost Chart</h3>
          <div className="account-details">
            {accountName && <div className="account-name">{accountName}</div>}
            {provider && (
              <img
                src={
                  provider === 'azure'
                    ? AzureLogo
                    : provider === 'wasabi'
                    ? WasabiLogo
                    : AwsLogo
                }
              />
            )}
          </div>
        </div>
        {panel}
      </div>
    )
  }
}

export default TotalCostChart
